const TRANSFER_API_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/transfer`;

export const handleAutodeskVaultToUnanetProductsSync = async (syncFlow, masterConnectors) => {
  try {

    const token = localStorage.getItem('token');
    // Extract instance ID from syncFlow object (this is the sync flow instance ID)
    const flowId = syncFlow.instanceId;
    
    if (!flowId) {
      throw new Error('Instance ID is missing in syncFlow object');
    }
    
    // Prepare request URL with flow ID as the only parameter
    const url = `${TRANSFER_API_URL}/vault-unanetproducts-sync?flowId=${flowId}`;
    
    // Make simple API request without additional parameters
    const response = await fetch(url, {
      method: 'POST',
      headers: {
          'Authorization': `Bearer ${token}`,
        },
    });
    
    if (!response.ok) {
      const errorBody = await response.text();
      let message = response.statusText;
      try {
        const parsed = JSON.parse(errorBody);
        message = parsed.message || parsed.error || message;
      } catch (_) {
        if (errorBody?.trim()) message = errorBody;
      }
      throw new Error(message);
    }

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error in Vault to UNANET Products Sync (Steps 1-2):', error);
    throw error;
  }
};